import SignUp from "../../components/units/Signup/SignUp";

export default function SignUpPage() {
  return <SignUp />;
}
